const asyncActionType = type => ({
    pending: `${type}_PENDING`,
    success: `${type}_SUCCESS`,
    error: `${type}_ERROR`
  });

export const FETCH_PORTAL_TRAININGS = asyncActionType('aerosimple/trainings/FETCH_PORTAL_TRAININGS');
export const FETCH_TRAINING_DETAIL = asyncActionType('aerosimple/trainings/FETCH_TRAINING_DETAIL');
export const SAVE_CONTENT_INFO = asyncActionType('aerosimple/trainings/SAVE_CONTENT_INFO');
export const FETCH_TRAINING_DRAFT = asyncActionType('aerosimple/trainings/FETCH_TRAINING_DRAFT');
export const COMPLETE_PORTAL_TRAINING = asyncActionType('aerosimple/trainings/COMPLETE_PORTAL_TRAINING');
export const CLEARSTATE = asyncActionType('aerosimple/trainings/CLEARSTATE');
export const GET_SCORM_FILE_CONTENT = asyncActionType('aerosimple/trainings/GET_SCORM_FILE_CONTENT');
export const FATCH_SCORM_TRAINING_INFO = asyncActionType('aerosimple/trainings/FATCH_SCORM_TRAINING_INFO');
export const SAVE_SCORM_TRAINING_INFO = asyncActionType('aerosimple/trainings/SAVE_SCORM_TRAINING_INFO');
export const DOWNLOAD_TRAINING_CERTIFICATE = asyncActionType('aerosimple/trainingsDOWNLOAD_TRAINING_CERTIFICATE');
